import { RootState } from "../../applicationStore";
import { createSelector } from "@reduxjs/toolkit";
import { LOADING } from "../../../types";
import { AreeState } from "../types/state";
import { TalesArea } from "../../../utils/types/TalesArea";

export const getAreeState = (state: RootState): AreeState => state.aree;

export const getAreeData = createSelector(
  getAreeState,
  (areeState): TalesArea[] | null => areeState?.data,
);

export const getAreeError = createSelector(
  getAreeState,
  (areeState): string | null => areeState?.error,
);

export const isAreeLoading = createSelector(
  getAreeState,
  (areeState): boolean => areeState?.loading === LOADING.PENDING ?? false,
);
